module.exports = __webpack_public_path__ + "images/441e8ba8cb24a9faa0f92dce0fa74821.png";